import { Page } from "@/models/page-models/Page";

export const AllNotifications: Page = {
  "path": "all-notifications",
  "name": "All Notifications",
  "props": {
    "data": {
      "title": "All Notifications",
      "printable": "FALSE",
      "url": "all-notifications",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Mark All As Read",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openWarningPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Mark All Notifications As Read"
                      },
                      "name": "openWarningPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "error"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "checkbox",
                  "variable": "formData.notificationForm.filterMentions",
                  "label": "Show Only Direct Mentions",
                  "disabled": "FALSE",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "getNotifications",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/notifications",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.notifications",
                        "arg3Key": "postData",
                        "arg3Value": "formData.notificationForm"
                      },
                      "name": "getNotifications",
                      "executeOnce": true
                    }
                  ]
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Notifications",
                  "disabled": "FALSE",
                  "items": "fetchedData.notifications.data.docs",
                  "headers": [
                    {
                      "value": "createdBy.displayName",
                      "text": "User"
                    },
                    {
                      "value": "title",
                      "text": "Title",
                      "type": "url",
                      "url": "{{__item.url}}"
                    },
                    {
                      "value": "createdAt",
                      "text": "Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}},show-time)"
                    },
                    {
                      "value": "isRead",
                      "text": "Read Status",
                      "type": "formula",
                      "formula": "fn(CONDITIONAL,{{__item.isRead}},Read,Unread)"
                    }
                  ],
                  "tableType": "static",
                  "selectableUniqueId": "_id",
                  "groupActions": [
                    {
                      "label": "Mark as Read",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "markNotificationAsRead",
                            "type": "fnSubmit",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v1/notifications/{{__item._id}}/markRead",
                            "arg2Key": "postData",
                            "arg2Value": "{}",
                            "arg3Key": "requestMethod",
                            "arg3Value": "PATCH"
                          },
                          "name": "markNotificationAsRead"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "copyDefaultNotificationForm",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDefaultNotificationForm",
                            "arg2Key": "destinationKey",
                            "arg2Value": "formData.notificationForm"
                          },
                          "name": "copyDefaultNotificationForm",
                          "executeOnce": true
                        },
                        {
                          "executionOrder": 3,
                          "pageFunction": {
                            "name": "getNotifications",
                            "type": "fnGetData",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v1/notifications",
                            "arg2Key": "storeInVar",
                            "arg2Value": "fetchedData.notifications",
                            "arg3Key": "postData",
                            "arg3Value": "formData.notificationForm"
                          },
                          "name": "getNotifications",
                          "executeOnce": true
                        }
                      ]
                    },
                    {
                      "label": "Mark as Unread",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "markNotificationAsUnread",
                            "type": "fnSubmit",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v1/notifications/{{__item._id}}/markUnread",
                            "arg2Key": "postData",
                            "arg2Value": "{}",
                            "arg3Key": "requestMethod",
                            "arg3Value": "PATCH"
                          },
                          "name": "markNotificationAsUnread"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "copyDefaultNotificationForm",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDefaultNotificationForm",
                            "arg2Key": "destinationKey",
                            "arg2Value": "formData.notificationForm"
                          },
                          "name": "copyDefaultNotificationForm",
                          "executeOnce": true
                        },
                        {
                          "executionOrder": 3,
                          "pageFunction": {
                            "name": "getNotifications",
                            "type": "fnGetData",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v1/notifications",
                            "arg2Key": "storeInVar",
                            "arg2Value": "fetchedData.notifications",
                            "arg3Key": "postData",
                            "arg3Value": "formData.notificationForm"
                          },
                          "name": "getNotifications",
                          "executeOnce": true
                        }
                      ]
                    }
                  ],
                  "neverHideActionBar": true,
                  "pagination": {
                    "pageVariable": "formData.notificationForm.page",
                    "serverItemsLengthVariable": "fetchedData.notifications.data.totalDocs",
                    "pageChangeFns": [
                      {
                        "executionOrder": 1,
                        "pageFunction": {
                          "name": "getNotifications",
                          "type": "fnGetData",
                          "arg1Key": "apiUrl",
                          "arg1Value": "/api/v1/notifications",
                          "arg2Key": "storeInVar",
                          "arg2Value": "fetchedData.notifications",
                          "arg3Key": "postData",
                          "arg3Value": "formData.notificationForm"
                        },
                        "name": "getNotifications",
                        "executeOnce": true
                      }
                    ],
                    "itemsPerPageVariable": "formData.notificationForm.limit"
                  }
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Mark All Notifications As Read",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "labelType": "formula",
                  "formula": "Are you sure?"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Confirm",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "markAllAsRead",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/notifications/markAllRead",
                    "arg2Key": "postData",
                    "arg2Value": "{}",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "PATCH"
                  },
                  "name": "markAllAsRead"
                }
              ]
            }
          ],
          "width": "400"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyDefaultNotificationForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultNotificationForm",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.notificationForm"
        },
        "name": "copyDefaultNotificationForm",
        "executeOnce": true
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getNotifications",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/notifications",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.notifications",
          "arg3Key": "postData",
          "arg3Value": "formData.notificationForm"
        },
        "name": "getNotifications",
        "executeOnce": true
      }
    ],
    "functions": [
      {
        "name": "getDefaultNotificationForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "filterMentions": true 
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "*",
  "visible": false
}